import { useEffect } from 'react';

type KeyboardShortcutOptions = {
    shortcuts: Record<KeyboardEvent['key'], (() => void) | undefined>;
    isActive?: boolean;
};

const isTypingField = (element: HTMLElement | null) => {
    const blacklistedKeys = ['INPUT', 'TEXTAREA', 'SELECT', 'BUTTON'];

    return (
        blacklistedKeys.includes(element?.tagName || '') ||
        (element instanceof HTMLElement && element.isContentEditable)
    );
};

export const useKeyboardShortcut = ({
    shortcuts = {},
    isActive = true,
}: KeyboardShortcutOptions) => {
    useEffect(() => {
        if (!isActive) return;

        const handleKeyDown = (event: KeyboardEvent) => {
            const activeElement = document.activeElement as HTMLElement | null;
            const disallowedKeys = ['Backspace', 'Delete', 'Enter'];

            if (
                isTypingField(activeElement) &&
                disallowedKeys.includes(event.key)
            ) {
                return;
            }

            const action = shortcuts[event.key];

            if (action) {
                event.preventDefault();
                action();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [shortcuts, isActive]);
};
